module.exports = __webpack_public_path__ + "static/media/menu_blk.0fe5da21.svg";